/**
 *
 * @class TimeStateModel
 * @desc A model representing the time related state of the player at any given moment
 * @module TimeStateModel
 *
 */
class TimeStateModel {

    /**
     *
     * @constructor
     *
     */
    constructor() {

        /**
         *
         * @type {boolean}
         * @desc If the media is Live (`true`) or VOD (`false`)
         *
         */
        this.isLive = false;

        /**
         *
         * @type {boolean}
         * @desc If the live media is at live point or not. `false` unless `isLive` is `true` and the media is at live point or within an acceptable range of the live point.
         *
         */
        this.isAtLivePoint = false;

        /**
         *
         * @type {number}
         * @desc The current time of playback in seconds.
         *
         */

        /**
         *
         * @type {object}
         * @desc describe the range of media that its seekable
         *
         */
        this.seekableRange = {

            start: 0,
            end: 0,

        };

        this.currentTime = 0;

        /**
         *
         * @type {number}
         * @desc The duration of the media in seconds.
         *
         */
        this.duration = 0;

        /**
         *
         * @type {number}
         * @desc The buffered amount in seconds.
         *
         */
        this.bufferedValue = 0;

        /**
         *
         * @type {boolean}
         * @desc If the player is seeking or not.
         *
         */
        this.seeking = false;

    }

    /**
     *
     * @desc Sets the player sate when the MEDIA_SEEKED event is dispatched
     *
     */
    setMediaSeekedState() {

        this.seeking = false;

    }

    /**
     *
     * @desc Sets the player sate when the MEDIA_SEEKING event is dispatched
     *
     */
    setMediaSeekingState() {

        this.seeking = true;

    }

    /**
     *
     * @desc Sets the player sate when the TIME_UPDATE event is dispatched
     * @param {number} currentTime The current time in seconds
     *
     */
    setMediaTimeupdateState(currentTime) {

        this.currentTime = currentTime;
        if (this.isLive) {

            this.updateIsAtLivePoint();

        }


    }

    /**
     *
     * @desc Set the player state when the DURATION_CHANGE event is dispatched
     * @param {number} duration The duration in seconds
     *
     */
    setMediaDurationChangeState(duration) {

        this.duration = duration;
        this.updateSeekableRange(this.duration);

        if (this.isLive) {

            this.updateIsAtLivePoint();

        }

    }

    /**
     *
     * @desc Set the player state when the DURATION_CHANGE event is dispatched
     * @param {boolean} isLive
     *
     */
    setLevelLoadedState(isLive, targetduration, streamStart) {

        this.isLive = isLive;
        this.targetduration = targetduration;
        this.seekableRange.start = streamStart;

    }

    /**
     *
     * @desc Update Seekable range
     * @param {number} duration the duration used to calculate the seekable range end
     * @todo modify the start of the seekable range on sliding window streams
     */

    updateSeekableRange(duration) {

        if (this.isLive) {

            //this is a calculation sugested by the HLS.JS team, this provides the latest safe point to seek to on live streams
            this.seekableRange.end = duration - 3 * this.targetduration;

        } else {

            // for VOD content the end of the seekableRange its the duration of the stream
            this.seekableRange.end = duration;

        }

    }

    /**
     *
     * @desc Update isAtLivePoint based on the current time
     *
     */

    updateIsAtLivePoint() {

        //check if we need to update the isAtLivePoint property, i took the 8 from bam-hls implementation
        // @todo make this configurable
        this.isAtLivePoint = (this.seekableRange.end - this.currentTime) < 8;

    }

}

export default TimeStateModel;
